import { FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// Types
import UserRoles from 'app/types/UserRoles';
// Models
import { IMyUser } from 'app/models/User';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectMyUser } from 'app/store/Users/Users.selectors';
// Mui
import { Divider, ListItemButton, ListItemText } from '@mui/material';

type Props = {
  onClose: () => void;
};

const StaffMenuItems:FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();
  // State
  const myUser:IMyUser | null = useAppSelector(selectMyUser);

  const listItems = [
    { to: '/admin/cases', type: 'item', label: t('components.userDrawer.cases') },
    { to: '/admin/calendar', type: 'item', label: t('components.userDrawer.companyCalendar') },
    { to: '/admin/ai-prompt-hub', type: 'item', label: t('components.userDrawer.aiPromptHub') },
    { to: '/admin/automated-workflows', type: 'item', label: t('components.userDrawer.automatedWorkflows') },
    { type: 'divider' }
  ];

  if ( !myUser || myUser.role !== UserRoles.Staff ) return null;
  return (
    <Fragment>
      {listItems.map((listItem:any, index:number) => {
        if ( listItem.type === 'divider' ) return (
          <Divider key={`user menu list divider ${index}`} component="li" />
        );
        return (
          <ListItemButton
            key={`user menu list item ${index}`}
            component={Link}
            to={listItem.to}
            onClick={onClose}
            sx={{ textTransform: 'capitalize' }}
          ><ListItemText primary={listItem.label} /></ListItemButton>
        );
      })}
    </Fragment>
  );
}

export default StaffMenuItems;
